export function checkNumberEmpty(input: number|null): boolean {
    return input === null;
}

export function checkHeadingInValid(input: number|null): boolean {
    if (input === null) return true;
    return input < 0 || input > 360;
}
